import { merge } from "lodash"

import { isPhoneRefusal } from "./submitRefusal"

export const DefaultState = {
  currentStep: 1,
  furthestStepReached: 1,
  furthestJourneyStepReached: 0,
  contractDetailsSeen: false,
  marinaTermsAccepted: false,
  dockwaTermsAccepted: false,
  declined: false,
  expired: false,
  docusealFormSubmitted: false,
  docusealFormSubmittedAt: null,
  reviewReady: false,
  reviewFallback: false,
  review: null,
  submitFailure: null,
  paymentMethod: "",
  paymentMethods: [],
  paymentType: "",
  signature: "",
  additionalInformation: {},
  additionalInformationFiles: {},
  requiredInformation: {
    phone: "",
    insurance: {
      companyName: "",
      policyNumber: "",
      document: false,
      documentError: null,
      documentValidating: false,
      replacingDocument: false,
      expirationDate: null,
    },
    registration: {
      registrationNumber: "",
      document: false,
      documentError: null,
      documentValidating: false,
      replacingDocument: false,
      expirationDate: null,
    },
  },
}

const signContractWizardReducer = (state, action) => {
  switch (action.type) {
    case "SET_CURRENT_STEP":
      return {
        ...state,
        currentStep: action.payload,
        furthestStepReached: Math.max(
          state.furthestStepReached,
          action.payload
        ),
      }
    case "GO_TO_NEXT_STEP": {
      const currentStep = state.currentStep + 1
      return {
        ...state,
        currentStep,
        furthestStepReached: Math.max(state.furthestStepReached, currentStep),
      }
    }
    case "GO_TO_PREVIOUS_STEP": {
      const currentStep = state.currentStep - 1
      return {
        ...state,
        currentStep,
        furthestStepReached: Math.max(state.furthestStepReached, currentStep),
      }
    }
    case "CONTRACT_DETAILS_SEEN":
      return { ...state, contractDetailsSeen: true }
    case "PAYMENT_METHOD_SELECTED": {
      let paymentType = ""

      if (action.payload === "manual") {
        paymentType = "manual"
      } else if (action.payload) {
        paymentType = "credit"
      }

      return {
        ...state,
        paymentMethod: action.payload,
        paymentType,
      }
    }
    case "PAYMENT_METHOD_ADDED":
      return merge(
        {},
        state,
        {
          paymentMethods: [...state.paymentMethods, action.payload],
        },
        {
          paymentMethod: action.payload.stripePaymentMethodId,
          paymentType: "credit",
        }
      )
    case "REQUIRED_INFORMATION_CHANGED": {
      const next = merge({}, state, { requiredInformation: action.payload })
      return "phone" in action.payload && isPhoneRefusal(state.submitFailure)
        ? { ...next, submitFailure: null }
        : next
    }
    case "ADDITIONAL_INFORMATION_CHANGED":
      return merge({}, state, {
        additionalInformation: action.payload,
      })
    case "ADDITIONAL_INFORMATION_FILE_ATTACHED": {
      const { id, signedId, name, size } = action.payload
      return {
        ...state,
        additionalInformation: {
          ...state.additionalInformation,
          [id]: signedId,
        },
        additionalInformationFiles: {
          ...state.additionalInformationFiles,
          [id]: { name, size },
        },
      }
    }
    case "ADDITIONAL_INFORMATION_FILE_REMOVED": {
      const { [action.payload]: _removed, ...files } =
        state.additionalInformationFiles
      return {
        ...state,
        additionalInformation: {
          ...state.additionalInformation,
          [action.payload]: "",
        },
        additionalInformationFiles: files,
      }
    }
    case "SIGNATURE_UPDATED":
      return { ...state, signature: action.payload }
    case "MARINA_TERMS_UPDATED":
      return { ...state, marinaTermsAccepted: action.payload }
    case "DOCKWA_TERMS_UPDATED":
      return { ...state, dockwaTermsAccepted: action.payload }
    case "CONTRACT_DECLINED":
      return { ...state, declined: true }
    case "CONTRACT_EXPIRED":
      return { ...state, expired: true }
    case "DOCUSEAL_FORM_SUBMITTED":
      return {
        ...state,
        docusealFormSubmitted: true,
        docusealFormSubmittedAt: action.payload?.fresh
          ? Date.now()
          : state.docusealFormSubmittedAt ?? Date.now(),
        reviewFallback: action.payload?.fresh ? false : state.reviewFallback,
      }
    case "REVIEW_CONFIRMATION_FAILED":
      return { ...state, reviewFallback: true }
    case "REVIEW_LOADED":
      return {
        ...state,
        review: action.payload,
        reviewReady: action.payload.status === "signed",
        reviewFallback:
          action.payload.status === "signed" ? false : state.reviewFallback,
        docusealFormCompleted:
          action.payload.status === "signed" || state.docusealFormCompleted,
      }
    case "SUBMIT_FAILED":
      return { ...state, submitFailure: action.payload }
    case "SUBMIT_FAILURE_CLEARED":
      return { ...state, submitFailure: null }
    case "STEP_REACHED":
      return {
        ...state,
        furthestJourneyStepReached: Math.max(
          state.furthestJourneyStepReached,
          action.payload
        ),
      }
    default:
      return state
  }
}

export default signContractWizardReducer
